module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('em', [_vm._v("One")])])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "nonindentc"
  }, [_c('em', [_vm._v("Dallas, Texas")]), _c('br'), _c('em', [_vm._v("December 11th, Present day")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("The baby kicked in China’s belly as she bent down to pick up her bag, a frightening reminder that she wasn’t the only person about to become homeless. George Wayne, her landlord, shifted nervously behind her as he stood in the doorway to the apartment, watching her gather her assortment of meager belongings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It ain’t my fault, you know. Rules is rules, and you’re more than three months behind on rent.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China turned, the bag in her hand, her head held high. “If you’d told me sooner that Tommy wasn’t giving you the rent money, I wouldn’t have kept giving it to him. I would have given it to you myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("George Wayne frowned. “That’s what you say, but you ain’t got no way of provin’ that to me. For all I know, you both partied up the money, and when it was all gone, he split on you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("China’s heart sank. The fact that Tommy Fairheart, ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("the father of her unborn child, had disappeared from her life eight days earlier was secondary to the fact that he’d stolen every penny she had to her name when he left. That he had also kept the last three months’ rent money instead of paying George Wayne, as China had believed, was, as the old saying went, the last straw.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She gave George a scathing look, pulled the front of her coat as far as it would go across her tummy and shouldered her bag. With her head held high, she moved past George in long, stilted strides, hoping she could get out of his sight before she started to cry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was a long walk from the third floor of her apartment down to street level. She made it in record time. But her defiance died when she stepped out the door and turned to face the bitter bite of Texas winter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again the baby kicked, then rolled. China placed her hand across the swell of her stomach and shifted the strap of her bag to a more comfortable position on her shoulder. Her mouth was twisted into a bitter grimace, her eyes flooded with tears, but there was determination in her voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t worry, baby. Mama will take care of you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Uncertain as to how that would yet come to be, she started walking. Her plan was to find a church. She’d seen several on the bus route that she rode every day to work. Maybe there would be someone there who could give her some temporary shelter. She had a job waiting tables in a barbeque joint. The pay wasn’t much, but the tips were good. All she needed was a ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("place to stay until she could save up enough money for another apartment.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For thirty minutes her hopes were high, but after more than a mile of walking and still no sign of any church, she began to get nervous. Her feet were so cold she could no longer feel her toes, and though she’d dressed as warmly as possible in sweatpants and a sweatshirt and two pairs of socks, her lack of gloves and the bite of the wind against her flesh was taking its toll. And, as if that wasn’t enough, to add insult to injury, it started to snow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Minuscule bits of something that felt more like sleet than snow stung her eyes. She squinted and ducked her head against a cruel winter gust that parted her coat. With shaking hands, she yanked it back over her belly, as if trying to shelter the child she was carrying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A garbage truck rumbled past her as she paused at a street comer to get her bearings. She told herself that the pain in her lower back didn’t matter. The buildings looked festive in their Christmas decorations, but she didn’t see anything that resembled a church. As she waited for the light to change, she couldn’t help but wish she’d paid more attention to the route the bus had taken instead of putting on her makeup and adding the finishing touches to her hair as she’d ridden to work each day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s got to be one around here somewhere,” she said, and headed for a florist on the opposite side of the street to ask for directions.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("As she stepped inside Red River Floral and closed ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("the door behind her, the strains of “White Christmas” filled the air. She leaned against the door to rest, letting the warmth envelope her.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, honey, can I help you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China’s focus shifted at the woman’s approach. She was broad and tall, and had the reddest hair she’d ever seen. It took China a bit to realize that a goodly portion of her height came from the highly teased hairstyle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Um… yes, I hope so,” China said. “I’m looking for a church.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The redhead grinned. “You lookin’ to join it or…”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” China said. “I’m sort of lost, and I thought someone there could help me. I saw plenty of them when I rode the bus to work, but now I can’t seem to find a single one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You ride the bus?” the redhead asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then why didn’t you just get back on that bus and ride it to the church?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China shrank within herself. Admitting she didn’t have a dime to her name wasn’t something she was comfortable with, especially to a stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I missed it, that’s all,” she said shortly. “Can you help me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The redhead’s smile shifted slightly as compassion filled her eyes. “Well, sure. We’ll get the phone book and take us a look. How’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China smiled. “I would appreciate it,” she said softly, and unconsciously patted the swell of her belly as she followed the woman to the back of the store.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("While they were in the midst of searching the yellow pages, a bell jingled, signaling the appearance of another customer, and this time a paying one.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excuse me just a minute,” the florist said, and moved toward the customer, leaving China alone at the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She scanned the listings, one by one, trying to figure out where she was in accordance with the nearest churches. At this point she wasn’t in a position to be picky about denomination; all she wanted from them was charity. She was still looking at addresses when the florist and the customer came to the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Find what you’re looking for?” the florist asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China shrugged. “I’m not sure. Are any of these churches nearby?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The customer, a tall, well-dressed woman in her midthirties, gave China an impatient stare.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m in a hurry,” she said, eyeing the florist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I’m sorry,” the florist said, and began writing the work order.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you mind?” the woman drawled, elbowing China out of the way in order to set her purse on the counter, then staring pointedly at China’s bag on the floor between them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The woman’s attitude was nothing more than another slap in China’s face, and for a woman who’d already had one too many blows to her self-esteem that day, it was one too many.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("China picked up her bag and headed for the door without getting the address she’d come for.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("“Wait, honey!” the florist called. “I’ll be with you in a minute.”")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("China paused, then turned, the length of the store carrying the clear, quiet tone of her message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you for being so kind.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A frigid blast of wind and its accompanying sleet hit her squarely in the face, reminding her of why she’d sought shelter there. She’d wasted precious time and still didn’t know any more now than she had when she went in. She hesitated, considering going back inside, when she caught a glimpse of herself in the store window. Her hair was wild and windblown, her cheeks reddened from exposure. Her all-around appearance was bedraggled. With the bag hanging over her shoulder, she looked like the homeless people she often saw walking the streets. And in that moment, the bitter truth of her situation hit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She didn’t just look like one. She had become one.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecbbaa54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/chapter1.vue
// module id = 84
// module chunks = 0